import { render, staticRenderFns } from "./4mTargetJobRisk.vue?vue&type=template&id=49c2a38d"
import script from "./4mTargetJobRisk.vue?vue&type=script&lang=js"
export * from "./4mTargetJobRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c2a38d')) {
      api.createRecord('49c2a38d', component.options)
    } else {
      api.reload('49c2a38d', component.options)
    }
    module.hot.accept("./4mTargetJobRisk.vue?vue&type=template&id=49c2a38d", function () {
      api.rerender('49c2a38d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/plan/4mTargetJobRisk.vue"
export default component.exports